<div id="printContainer" #printContainer style="visibility: hidden;">
    <header class="baer-header">
        <div *ngIf='report?.assessment' class="breadcrumb"><a routerLink="/assessments">BAER Assessments</a> &gt; <a
                [routerLink]="'/fire-overview'"
                [queryParams]="{assessment_id: report?.assessment?.assessment_id}">{{report?.assessment?.baer_name}}</a>
            &gt; {{ report?.baer_name }} ({{report?.report_num}})</div>
        <h1 id="table" class="site-page-title" *ngIf="report"><span class="large-font">{{report.baer_name}}
                ({{report.report_num}})</span></h1>
        <div class="status-div" *ngIf="report">
            Report ID: {{ report.report_id }} <span class="spacer">|</span>Action: {{ "Initial" }}
        </div>
        <div class="status-div" *ngIf="report">
            Report Status:
            <mat-chip [ngClass]="'chip-r-'+report?.report_status_id">
                {{report.report_status_id | reportStatusBadge}}
            </mat-chip>
            @if (report.report_status_id == 2) {
            <span class="spacer">|</span>Authorization Status:
            <mat-chip [ngClass]="'chip-a-'+report?.authorization_status_id">
                {{report.authorization_status_id | authorizationStatusBadge}}
            </mat-chip>
            }
        </div>
    </header>
    <div class="report-main" *ngIf="report">
        <div class="report-right-area">
            <div class="report-area">
                <div #target1 class="report-section" [ngClass]="comment_expand ? 'report-section-comment' : ''"
                    *ngIf="report">
                    <ng-container *ngTemplateOutlet="underReview"></ng-container>
                    <ng-container *ngTemplateOutlet="submitted"></ng-container>
                    <ng-container *ngTemplateOutlet="regionalFundingRecommendation"></ng-container>
                    @if(report_type == "No Treatment") {
                <app-view-report-type id="report-type" [report]="report"></app-view-report-type>
                <app-view-burned-area id="burned-area" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-burned-area>
                <app-view-watershed-condition id="watershed-condition" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-watershed-condition>
                <app-view-analysis-summary id="analysis-summary" [report]="report"
                    (loaded)="subLoaded($event)" [forPDF]="true"></app-view-analysis-summary>
                <app-view-recommended-treatment id="recommended-treatment" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-recommended-treatment>
                <app-view-assessment-cost id="assessment-cost" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-assessment-cost>
                <app-view-team-supporting id="team-supporting" [report]="report" page="6"
                    (loaded)="subLoaded($event)"></app-view-team-supporting>
                <app-view-select-line-officer id="select-line-officer" [report]="report" page="7"
                    (loaded)="subLoaded($event)"></app-view-select-line-officer>
                <app-view-lo-signatures id="view-lo-signatures" [report]="report"></app-view-lo-signatures>
                } @else if (report_type == "Pre-assessment Request") {
                <app-view-report-type id="report-type" [report]="report"></app-view-report-type>
                <app-view-burned-area id="burned-area" [report]="report" [simple]="true"
                    (loaded)="subLoaded($event)"></app-view-burned-area>
                <app-view-analysis-summary id="analysis-summary" [report]="report" [simple]="true"
                    (loaded)="subLoaded($event)" [forPDF]="true"></app-view-analysis-summary>
                <app-view-recommended-treatment id="recommended-treatment" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-recommended-treatment>
                <app-view-emergency-stabilization id="emergency-stabilization" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-emergency-stabilization>
                <app-view-team-supporting id="team-supporting" [report]="report" page="6"
                    (loaded)="subLoaded($event)"></app-view-team-supporting>
                <app-view-select-line-officer id="select-line-officer" [report]="report" page="7"
                    (loaded)="subLoaded($event)"></app-view-select-line-officer>
                <app-view-lo-signatures id="view-lo-signatures" [report]="report"></app-view-lo-signatures>
                } @else {
                <app-view-report-type id="report-type" [report]="report"></app-view-report-type>
                <app-view-burned-area id="burned-area" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-burned-area>
                <app-view-watershed-condition id="watershed-condition" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-watershed-condition>
                <app-view-analysis-summary id="analysis-summary" [report]="report"
                    (loaded)="subLoaded($event)" [forPDF]="true"></app-view-analysis-summary>
                <app-view-recommended-treatment id="recommended-treatment" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-recommended-treatment>
                <app-view-emergency-stabilization id="emergency-stabilization" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-emergency-stabilization>
                <app-view-team-supporting id="team-supporting" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-team-supporting>
                <app-view-select-line-officer id="select-line-officer" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-select-line-officer>
                <app-view-lo-signatures id="view-lo-signatures" [report]="report"></app-view-lo-signatures>
                }
                </div>
            </div>
            <div class="report-footer" *ngIf="signable">
            </div>
            <div class="report-footer" *ngIf="submitable">
            </div>
        </div>
    </div>

    <ng-template #underReview>
        <div class="yellow-warning" *ngIf="report.report_status_id == 3 && !is_co">
            <fa-icon [icon]="faFile" class="faFile" aria-label="Warning"></fa-icon>
            <div class="support-text">
                <b>The report is under review by the Regional BAER Coordinator.</b>
                <span>
                    <br>
                </span>
                If additional information or changes are requested you will be notified in the Comments sidebar.
            </div>
        </div>
    </ng-template>
    <ng-template #readyRegionalFunding>
        <div class="yellow-warning">
            <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
            <div class="support-text">
                <b>Report is ready for Regional Funding Recommendations.</b>
            </div>
        </div>
    </ng-template>
    <ng-template #submitted>
        <div class="green-box" *ngIf="report.report_status_id == 2 && report.authorization_status_id == 0">
            <i class="material-icons check-icon">check_circle</i>
            <div class="support-text">
                <b>Report submitted to the forest unit line officer(s) for signature and certification.</b>
                <span>
                    <br>
                </span>
                Report submitted on {{ report.submission_date | date:"MM/dd/yyyy" }}
            </div>
        </div>
    </ng-template>
    <ng-template #regionalFundingRecommendation>
        <div class="yellow-warning" *ngIf="report.report_status_id == 2 && report.authorization_status_id == 3">
            <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
            <div class="support-text">
                <b>Report is Ready for Regional Funding Recommendations.</b>
            </div>
        </div>
    </ng-template>
</div>